// Rutas que son "pantallas-tab" de la barra de navegación inferior en mobile.
//
// La barra SOLO se muestra en estas rutas, y el header mobile oculta el botón
// "back" en ellas (son raíces de navegación: se cambian con las tabs, no con
// back).
//
// El landing de Estudio (selección de productos) muestra la barra en su estado
// raíz; cuando el usuario selecciona productos aparece su CTA de generar y la
// página oculta la barra vía `mobileHideBottomNav` (modo tarea).
/**
 * Pantallas del shell nuevo donde la barra inferior NO va —
 * ADR-2026-08-05-la-barra-no-va-en-las-pantallas-tarea.
 *
 * La barra es navegación entre SECCIONES. Estas no lo son: son tareas a pantalla
 * completa que traen su propia barra de acciones abajo (los editores) o su propio
 * cierre. Con la barra encima, sus controles quedaban cortados por detrás — pasó al
 * entrar "Editar imagen" al shell.
 *
 * Va por ruta y no con el flag `mobileHideBottomNav` del contexto porque ese flag es
 * global y depende de que cada pantalla lo prenda al montar y lo apague al salir: si
 * una se olvida —o el cleanup no llega a correr— la barra se apaga en la siguiente,
 * que es justamente lo que estaba pasando. Los dos criterios conviven: éste es
 * estructural (qué pantalla es) y el flag sigue siendo el dinámico (en qué paso está).
 */
export const MOBILE_RUTAS_SIN_NAV = [
  // Tienda online (la lista y la ficha de cada producto): trae sus propias acciones arriba y la barra
  // de abajo a la lista (ADR-2026-10-30-tienda-online-en-el-telefono).
  "/lanzamientos",
  // Instagram (el calendario): pantalla de trabajo con su propio "Nuevo post" flotante abajo
  // (ADR-2026-11-02-instagram-sin-barra-en-el-telefono).
  "/instagram",
  "/redes-sociales/edicion-grafica",
  "/redes-sociales/editar-imagen",
  "/redes-sociales/editar-video",
  "/redes-sociales/editar-video-ia",
  "/exportar-tiendanube",
  "/subscription",
  // "Ambiente completo": la pantalla del modo ocupa el viewport entero y trae su propia
  // barra abajo —el "Siguiente" del paso 1 y el Generar del paso 2—, que la de
  // navegación tapaba (ADR-2026-09-10-ambiente-completo-en-el-telefono).
  "/ambiente-completo",
  // Los otros dos modos de Hogar y Decoración, por lo mismo: los dos pasos terminan en su
  // propio pie fijo y la barra de navegación se lo comía
  // (ADR-2026-09-10-los-modos-de-deco-en-el-telefono).
  "/variantes-de-acabado",
  "/mostrar-como-funciona",
  // El Estudio de Video de un proyecto: pantalla-herramienta completa, con su
  // propia barra de herramientas abajo (ADR-2026-09-16-el-estudio-de-video-en-el-telefono).
  // Va con la barra final para NO tomar `/editor-video` a secas —la lista de
  // proyectos, que sí conserva la navegación.
  "/editor-video/",
  // El Catálogo con el agente en el teléfono: la grilla con su "Siguiente" al pie y, en la
  // sesión, la pastilla del agente y las acciones abajo; la barra de navegación las tapaba
  // (ADR-2026-10-15-el-catalogo-en-el-telefono-2). Sólo `/catalogo` y `/catalogo/:id`.
  "/catalogo",
  // "Subir productos" de Mi marca y sus consejos: tareas con su propia barra de Guardar /
  // Crear abajo o su propio volver (ADR-2026-10-13-subir-productos-es-una-pantalla y
  // ADR-2026-10-13-subir-productos-pantalla-de-consejos).
  "/mi-marca/productos/",
];

export const MOBILE_BOTTOM_NAV_PATHS = [
  "/interfaz-v2",
  "/modos",
  "/mi-marca",
  "/redes-sociales/imagenes",
];
